import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { useHeader } from './hooks/useHeader';

export const Header: React.FC = () => {
	const { headline, description } = useHeader();

	return (
		<>
			<Text
				as="h1"
				variant="heading"
				size="small"
				fontWeight="bold"
				data-qa="ppmu-modal-header-title"
				className="text-typography-strong mb-2"
			>
				{headline}
			</Text>
			<Text variant="body" size="medium" data-qa="ppmu-modal-header-description" className="text-typography-weak">
				{description}
			</Text>
		</>
	);
};
